export const PageDescription = ({
  title,
  subtitle
}: {
  title: string,
  subtitle: string
}
) => {
  return (
    <div className={`flex flex-col items-start justify-start mb-10`}>
      <h1 className="text-primary font-semibold text-2xl mb-1">
        {title}
      </h1>
      <h2 className="text-secondary font-medium text-xl">
        {subtitle}
      </h2>
    </div>
  )
}
